module.exports = __webpack_public_path__ + "static/media/edit.e79a31ff.svg";